import { EXCHANGE_HOLIDAYS, EXCHANGE_HOLIDAYS_ERROR, EXCHANGE_HOLIDAYS_HIDE_ERROR, EXCHANGE_HOLIDAYS_START_LOADER, EXCHANGE_HOLIDAYS_STOP_LOADER, } from "@frameworks/web/redux/interfaces/StaticFooter/iExchangeHoliday";
import store from "@frameworks/web/redux/store";
class ExchangeHolidayActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getExchangeHolidayData(data) {
        this.dispatch({
            type: EXCHANGE_HOLIDAYS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: EXCHANGE_HOLIDAYS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: EXCHANGE_HOLIDAYS_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: EXCHANGE_HOLIDAYS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: EXCHANGE_HOLIDAYS_STOP_LOADER,
        });
    }
}
export default ExchangeHolidayActions;
